import { getIDToken } from "../utils/utils";
import * as config from "../config.js";

export const getClients = async () => {
  try {
    const response = await fetch(
      `${config.REST_SERVER_URL}/admin/client`,

      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "X-Access-Token": getIDToken(),
        },
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const createClient = async (name) => {
  // We dispatch requestLogin to kickoff the call to the API
  console.log("CREATING CLIENT: ", name);
  const url = `${config.REST_SERVER_URL}/admin/client`;
  const response = await fetch(url, {
    method: "POST",
    crossDomain: true,
    headers: {
      "Content-Type": "application/json",
      "X-Access-Token": getIDToken(),
    },
    body: JSON.stringify({
      name: name,
    }),
  }).catch((error) => {
    console.log("ERROR: ", error);
  });

  const client = await response.json();
  return client;
};

export const getAgents = async (clientID) => {
  const url = `${config.REST_SERVER_URL}/admin/client/agents/${clientID}`;
  const response = await fetch(url, {
    method: "GET",
    crossDomain: true,
    headers: {
      "Content-Type": "application/json",
      "X-Access-Token": getIDToken(),
    },
  }).catch((error) => {
    console.log("ERROR: ", error);
  });

  const results = await response.json();
  console.log("!!! AGENTS: ", results.agents);
  return results.agents;
};

export const getAllAgents = async () => {
  const url = `${config.REST_SERVER_URL}/admin/agent`;
  const response = await fetch(url, {
    method: "GET",
    crossDomain: true,
    headers: {
      "Content-Type": "application/json",
      "X-Access-Token": getIDToken(),
    },
  }).catch((error) => {
    console.log("ERROR: ", error);
  });

  const results = await response.json();
  console.log("!!! AGENTS: ", results.agents);
  return results.agents;
};

export const getMedia = async (clientID) => {
  const url = `${config.REST_SERVER_URL}/admin/client/media/${clientID}`;
  const response = await fetch(url, {
    method: "GET",
    crossDomain: true,
    headers: {
      "Content-Type": "application/json",
      "X-Access-Token": getIDToken(),
    },
  }).catch((error) => {
    console.log("ERROR: ", error);
  });

  const results = await response.json();
  console.log("!!! MEDIA: ", results.media);
  return results.media;
};

export const getSupportingContent = async (clientID) => {
  const url = `${config.REST_SERVER_URL}/admin/client/supportingcontent/${clientID}`;
  const response = await fetch(url, {
    method: "GET",
    crossDomain: true,
    headers: {
      "Content-Type": "application/json",
      "X-Access-Token": getIDToken(),
    },
  }).catch((error) => {
    console.log("ERROR: ", error);
  });

  const results = await response.json();
  return results.supportingcontent;
};

export const getUsers = async (clientID) => {
  const url = `${config.REST_SERVER_URL}/admin/client/users/${clientID}`;
  const response = await fetch(url, {
    method: "GET",
    crossDomain: true,
    headers: {
      "Content-Type": "application/json",
      "X-Access-Token": getIDToken(),
    },
  }).catch((error) => {
    console.log("ERROR: ", error);
  });

  const results = await response.json();
  return results.users;
  /*return results.users.filter(
    (user) => !user.email.match(/privaterelay\.appleid\.com/)
  );*/
};

export const getClientByUser = async (user_id) => {
  try {
    const response = await fetch(
      `${config.REST_SERVER_URL}/admin/user/client/${user_id}`,

      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "X-Access-Token": getIDToken(),
        },
      }
    );
    const data = await response.json();
    return data.client;
  } catch (error) {
    console.error(error);
  }
};

export const getAnalytics = async (clientID) => {
  const url = `${config.REST_SERVER_URL}/admin/client/analytics/${clientID}`;
  const response = await fetch(url, {
    method: "GET",
    crossDomain: true,
    headers: {
      "Content-Type": "application/json",
      "X-Access-Token": getIDToken(),
    },
  }).catch((error) => {
    console.log("ERROR: ", error);
  });

  const results = await response.json();
  return results.analytics;
};

export const getChatSessions = async (clientID) => {
  const url = `${config.REST_SERVER_URL}/admin/chat/chat_sessions/${clientID}`;
  const response = await fetch(url, {
    method: "GET",
    crossDomain: true,
    headers: {
      "Content-Type": "application/json",
      "X-Access-Token": getIDToken(),
    },
  }).catch((error) => {
    console.log("ERROR: ", error);
  });

  const results = await response.json();
  return results.chat_sessions;
};

export const getChatSession = async (sessionID) => {
  const url = `${config.REST_SERVER_URL}/admin/chat/session/${sessionID}`;
  const response = await fetch(url, {
    method: "GET",
    crossDomain: true,
    headers: {
      "Content-Type": "application/json",
      "X-Access-Token": getIDToken(),
    },
  }).catch((error) => {
    console.log("ERROR: ", error);
  });

  const results = await response.json();
  return results.chat_session;
};

export const getEvents = async (clientID) => {
  const url = `${config.REST_SERVER_URL}/admin/client/events/${clientID}`;
  const response = await fetch(url, {
    method: "GET",
    crossDomain: true,
    headers: {
      "Content-Type": "application/json",
      "X-Access-Token": getIDToken(),
    },
  }).catch((error) => {
    console.log("ERROR: ", error);
  });

  const results = await response.json();
  return results.events;
};

export const getEvent = async (sessionID) => {
  const url = `${config.REST_SERVER_URL}/admin/client/event/${sessionID}`;
  const response = await fetch(url, {
    method: "GET",
    crossDomain: true,
    headers: {
      "Content-Type": "application/json",
      "X-Access-Token": getIDToken(),
    },
  }).catch((error) => {
    console.log("ERROR: ", error);
  });

  const results = await response.json();
  return results?.events ?? [];
};

export const getEmails = async (clientID) => {
  const url = `${config.REST_SERVER_URL}/admin/client/emails/${clientID}`;
  const response = await fetch(url, {
    method: "GET",
    crossDomain: true,
    headers: {
      "Content-Type": "application/json",
      "X-Access-Token": getIDToken(),
    },
  }).catch((error) => {
    console.log("ERROR: ", error);
  });

  const results = await response.json();
  return results.emails;
};

export const getMessages = async (clientID) => {
  const url = `${config.REST_SERVER_URL}/admin/client/messages/${clientID}`;
  const response = await fetch(url, {
    method: "GET",
    crossDomain: true,
    headers: {
      "Content-Type": "application/json",
      "X-Access-Token": getIDToken(),
    },
  }).catch((error) => {
    console.log("ERROR: ", error);
  });

  const results = await response.json();
  return results.messages;
};

export const getEmail = async (sessionID) => {
  const url = `${config.REST_SERVER_URL}/admin/client/email/${sessionID}`;
  const response = await fetch(url, {
    method: "GET",
    crossDomain: true,
    headers: {
      "Content-Type": "application/json",
      "X-Access-Token": getIDToken(),
    },
  }).catch((error) => {
    console.log("ERROR: ", error);
  });

  const results = await response.json();
  return results?.emails ?? [];
};

export const getResponses = async (clientID) => {
  const url = `${config.REST_SERVER_URL}/admin/client/responses/${clientID}`;
  const response = await fetch(url, {
    method: "GET",
    crossDomain: true,
    headers: {
      "Content-Type": "application/json",
      "X-Access-Token": getIDToken(),
    },
  }).catch((error) => {
    console.log("ERROR: ", error);
  });

  const results = await response.json();
  console.log("!!! RESULTS");
  return results.responses;
};

export const getLiveEvents = async (clientID) => {
  const url = `${config.REST_SERVER_URL}/admin/client/liveevents/${clientID}`;
  const response = await fetch(url, {
    method: "GET",
    crossDomain: true,
    headers: {
      "Content-Type": "application/json",
      "X-Access-Token": getIDToken(),
    },
  }).catch((error) => {
    console.log("ERROR: ", error);
  });

  const results = await response.json();
  return results.live_events;
};
